import React, { Children, cloneElement, isValidElement, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslate } from 'ra-core';
import { Box } from '@material-ui/core'
import Menu from '@material-ui/core/Menu';
import { Avatar, Typography } from '@material-ui/core'
import { ArrowDropDown, AccountCircle } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import moment from 'moment-timezone';
import icClock from '../assets/icons/ic_clock.png';
import { baseAuthUrl } from '../authProvider';

const useStyles = makeStyles(
    theme => ({
        avartarLarge: {
            margin: 'auto 0',
            [theme.breakpoints.up('xs')]: {
                width: theme.spacing(7),
                height: theme.spacing(7),
            },
            [theme.breakpoints.down('xs')]: {
                width: theme.spacing(5),
                height: theme.spacing(5),
            },

        },
        iconClock: {
            width: 16,
            marginRight: 4
        },
        textEmail: {
            fontFamily: 'UniviaPro',
            fontSize: '11px',
            fontWeight: 'normal',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 1.36,
            letterSpacing: 'normal',
            color: '#4f5064',
            paddingBottom: "7px"
        },
        textRole: {
            fontFamily: 'UniviaPro',
            fontSize: '11px',
            fontWeight: 'normal',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 1.36,
            letterSpacing: 'normal',
            color: '#b4b5bd',
            paddingBottom: "7px"
        },
        textClock: {
            fontFamily: 'UniviaPro',
            fontSize: '11px',
            fontWeight: 'normal',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 1.5,
            letterSpacing: 'normal',
            color: '#4f5064',
        }
    })
);
const UserMenu = props => {
    const classes = useStyles(props);
    const [anchorEl, setAnchorEl] = useState(null);
    const translate = useTranslate();
    const [user, setUser] = useState()
    const isXSmall = useMediaQuery(theme => theme.breakpoints.down('xs'));
    const isDesktop = useMediaQuery(theme => theme.breakpoints.up('md'));
    const [currentTime, setCurentTime] = useState("")


    React.useEffect(() => {
        if (localStorage.getItem('userData')) {
            var data = JSON.parse(localStorage.getItem('userData'));
            setUser(data.user)
        }
        const loadTime = () => {
            let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            let currentTime = moment().tz(timezone).format('HH:mm/z');
            setCurentTime(currentTime);
        }
        setInterval(loadTime, 100)
    }, []);
    if (!user) return null;

    const { children, label, icon, logout } = props;
    if (!logout && !children) return null;
    const open = Boolean(anchorEl);
    const handleClose = () => setAnchorEl(null);


    return (
        <Box mr={isDesktop ? 5 : 3} ml={isDesktop ? 5 : 3}>
            <Box width='100%' display='flex' justifyContent='flex-end' alignContent='center'>
                <Avatar src={`${baseAuthUrl}${user.avatarURL}`} className={classes.avartarLarge} />
                {!isXSmall &&
                    (<Box ml={2} width='100%'>

                        <Typography style={{ cursor: 'pointer' }} className={classes.textEmail}>{user.email}</Typography>
                        <Typography className={classes.textClock} style={{ display: 'flex' }}><img width={16} height={16} src={icClock} className={classes.iconClock} />{currentTime}</Typography>
                    </Box>)}
                {
                    !isXSmall && <ArrowDropDown cursor='pointer' style={{ color: '#88898c' }} ></ArrowDropDown>
                }
            </Box>

            <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                {Children.map(children, menuItem =>
                    isValidElement(menuItem)
                        ? cloneElement(menuItem, {
                            onClick: handleClose,
                        })
                        : null
                )}
            </Menu>
        </Box>
    );
};

UserMenu.propTypes = {
    children: PropTypes.node,
    label: PropTypes.string.isRequired,
    logout: PropTypes.element,
    icon: PropTypes.node,
};

UserMenu.defaultProps = {
    label: 'ra.auth.user_menu',
    icon: <AccountCircle />,
};

export default UserMenu;